module.exports = __webpack_public_path__ + "img/icon-print-layout-vertical.8681d390.svg";